<template>
  <div style="margin: 0; padding: 0;">
    <vue-drawer-layout ref="drawer" :drawer-width="300" :enable="false" @mask-click="closeDrawer">

      <div slot="drawer">
        <NavigationDrawer :close="closeDrawer" class="navigation-drawer" />
      </div>

      <div slot="content" class="root-pane">
        <div>
          <InternetOnOff />
        </div>
        <!-- small screens -->
        <NavigationBar :toggle="openDrawer" class="nav" v-if="smallScreen" />
        <div class="navigation-route-view">
          <div class="m-1" v-if="smallScreen">
            <NewProductCategories />
            <div style="height: 50px">
              <MobileSearchedProducts :showMainCategories="showCategories" />
            </div>
          </div>

          <!-- Medium and large screens -->
          <div class="row m-1" v-if="!smallScreen" style="height: 95vh;">
            <div v-if="!smallScreen" class="col-md-6 col-lg-4">
              <div>
                <ProductCategories class="rows " />
                <NewShoppingChart class="rows" />
                
               
              </div>
            </div>
            <SearchedProducts v-if="!smallScreen" class="col-md-6 col-lg-8" />
            <FloatingInfo icon="fa-solid fa-bars" @click="openDrawer" />
          </div>
        </div>
      </div>
    </vue-drawer-layout>
  </div>

</template>

<script>
import FloatingInfo from "@/components/layout/utils/FloatingInfo.vue";
import NewShoppingChart from "@/components/point-of-sale/sales/pos/NewShoppingChart.vue";
import ProductCategories from "@/components/point-of-sale/sales/pos/ProductCategories.vue";
import SearchedProducts from "@/components/point-of-sale/sales/pos/SearchedProducts.vue";
import MobileSearchedProducts from "@/components/point-of-sale/sales/pos/MobileSearchedProducts.vue";
import ShoppingCart from "@/components/point-of-sale/sales/pos/ShoppingCart.vue";
import NewProductCategories from "@/components/point-of-sale/sales/pos/NewProductCategories.vue";
import NavigationDrawer from "@/components/layout/navigation/NavigationDrawer.vue";
import InternetOnOff from "@/components/layout/NetworkChecker.vue";
import NavigationBar from "@/components/layout/navigation/NavigationBar.vue";

export default {
  name: "POSView",
  components: {
    NavigationBar, InternetOnOff, FloatingInfo,
    NavigationDrawer, ShoppingCart, SearchedProducts, MobileSearchedProducts, ProductCategories, NewProductCategories, NewShoppingChart
  },
  computed: {
    smallScreen() {
      let windowWidth = this.$store.getters.getWindowWidth
      if (!windowWidth) {
        return false
      }

      return windowWidth < 768
    },
  },
  beforeMount() {
    this.getTableBySaleNumber();
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('pagehide', this.handlePageHide);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('pagehide', this.handlePageHide);
  },
  data() {
    return {
      saleNumber: this.$route.query.saleNumber,
      dontReload: this.$route.query.dontReload,
      selectCategory: true,
      shouldSaveOnLeave: false,
    }
  },
  methods: {
    openDrawer() {
      if (this.$store.getters.getSaleLines.length === 0) {
        this.$refs.drawer.toggle();
      }
    },
    handleBeforeUnload(e) {
      if (this.$store.getters.getSaleLines && this.$store.getters.getSaleLines.length > 0) {
   
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Do you want to save the table before leaving?';

        this.shouldSaveOnLeave = true;
        return e.returnValue;
      }
    },

    // Add this method to handle the actual saving when page is about to be hidden
    async handlePageHide() {
      if (this.shouldSaveOnLeave && this.$store.getters.getSaleLines && this.$store.getters.getSaleLines.length > 0) {
        try {
          // Prepare table data exactly like the updateTable action
          const saleLines = this.$store.getters.getSaleLines;
          const settings = this.$store.getters.getDeviceSettings || {};
          const user = this.$store.getters.getCurrentUser || {};
          
          // Calculate line totals like in the original updateTable action
          const processedSaleLines = saleLines.map(line => ({
            ...line,
            Line: (Number(line.Qty) * Number(line.Unit)) - Number(line.Discount)
          }));

          const tableData = {
            SaleNum: this.$store.getters.getCurrentSale,
            Name: this.$store.getters.getOpenTableName || `Table_${Date.now()}`,
            User: user.Username,
            PC: settings.PC,
            items: processedSaleLines,
            Customer: this.$store.getters.getCustomer,
            discount: parseFloat(this.$store.getters.getSaleDiscount?.total || 0),
          };

          const store = this.$store.getters.getDefaultStore || {};
          const apiUrl = `${serverApi}tables/${store.StoreDB}`;

      
          if (navigator.sendBeacon) {
          
            const jsonBlob = new Blob([JSON.stringify(tableData)], {
              type: 'application/json'
            });
            
            const success = navigator.sendBeacon(apiUrl, jsonBlob);
          
          } else {
           
            try {
              await this.$store.dispatch('updateTable', {
                name: tableData.Name,
                Customer: tableData.Customer
              });
            } catch (error) {
              console.error('Failed to save table:', error);
            }
          }

       
          this.$store.commit('clearSale');
          this.$store.commit(`setOpenTableName`, '')
          this.$store.commit('setIsTabOpen', false);
        } catch (error) {
          console.error('Error in handlePageHide:', error);
        }
      }
    },
    closeDrawer() {
      this.$refs.drawer.toggle(false);
    },
    getTableBySaleNumber() {
      if (this.dontReload || !this.saleNumber) {
        localStorage.removeItem('currentSaleLines')
        return
      };
      this.$utils.showLoading();
      return this.$store.dispatch(`getTableBySaleNumber`, this.saleNumber)
        .finally(() => this.$utils.hideLoading());
    },
    showCategories(value) {
      if (this.smallScreen) {
        this.selectCategory = value
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.getCurrentSale === 0 && this.$store.getters.getSaleLines.length === 0) return next();
    if (to.name === `instruction` || to.name === `payment` || to.name === `select-customer`
      || (to.name === `poslogin` && this.$store.getters.getSaleLines.length === 0)) {

      return next();
    } else if (to.name === `tables`) {
      if (!this.$store.getters.getOpenTableName) {
        this.$store.commit('setIsTabOpen', true)
        return Swal.fire({
          title: 'Table Name',
          icon: 'question',
          input: 'text',
          showCancelButton: true,
          confirmButtonText: 'Save Table',
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: (input) => {
            if (!input) return Swal.showValidationMessage(`Table name is required`);
            this.$store.commit(`setOpenTableName`, input)
            return this.$store.dispatch('saveNewTable', {
              name: input,
              Customer: this.$store.getters.getCustomer,
            }).then(() => input)
              .catch(error => Swal.showValidationMessage(error))
          },
        }).then((result) => {
          this.$store.commit('setIsTabOpen', false)
          if (result.isConfirmed) {
            return Swal.fire({
              title: `Success`,
              icon: 'success',
              text: `Table ${result.value} Saved`
            }).then(() => {
              this.$store.dispatch("clearLocalStorage");
              this.$store.commit('clearSale');
              this.$router.push({ name: `tables` });
            })
          }
        })
      }
      return Swal.fire({
        icon: "question",
        title: "Save this table ?",
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          let table = {};
          table.items = this.$store.getters.getSaleLines;
          table.Customer = this.$store.getters.getCustomer;
          table.name = this.$store.getters.getOpenTableName;
          return this.$store.dispatch('updateTable', table);
        }
      }).then(res => {
        if (res.isConfirmed) {
          this.$store.dispatch("clearLocalStorage");
          this.$store.commit('clearSale');
          next();
          this.$store.dispatch("clearLocalStorage");
          return responses.showInfo('Table successfully updated');
        }
        return responses.showWarning(`Save or Use Current Table`)
      })
    } else {
      return responses.showWarning(`Save or Use Current Table`);
    }
  }
}
</script>


<style scoped lang="scss">
.rows {
  display: block;
  max-height: 19rem;
}

.main-panel {
  background: white;
  padding: 5px;
  box-shadow: 0 0 18px rgba(39, 130, 243, 0.4);
  margin: -7px 5px 0px;
  height: 98%;
  max-height: 98%;
  border-radius: 6px;
  border: 1px solid #eee;
}

.offcanvas-body {
  flex-shrink: 0;
  height: 90vh;
  overflow-y: auto;
}

.root-pane {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

#app .root-pane {
  height: 0;
}

.navigation-drawer {
  min-width: 285px;
  width: 100%;
  height: 100vh;
}

.navigation-route-view {
  transition: 0.5s ease;
  //padding-bottom: 40px !important;
}

.offline-banner {
  position: sticky;
  top: 0;
  left: 0;
  padding: 5px;
  display: block;
  text-align: center;
  width: 100%;
  background: rgb(220, 53, 69);
  color: white;
  right: 0;
}
</style>